import React, {useEffect, useState,useRef} from 'react';
import makeStyles from '@material-ui/styles/makeStyles';
import Dialog from "@material-ui/core/Dialog";
import {DialogTitle} from "../../../components";
import DialogContent from "@material-ui/core/DialogContent";
import { MaterialTable } from '../../../components';

import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Grid from '@material-ui/core/Grid';
import Button from "@material-ui/core/Button";
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import Typography from "@material-ui/core/Typography";


import { useReactToPrint } from 'react-to-print';


const useStyles = makeStyles(theme => ({
    signInButton: {
        margin: theme.spacing(2, 0)
    },
    downloadPdfButton: {
        margin: theme.spacing(2, 0, 2, 2),
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(0),
        color: theme.palette.text.default,
      },
      reportContainer :{
        width:"100%",
      },
      formulationBox : {
        display:'grid',
        marginBottom:'5px'
      },
      red: {
        color: '#f44336',
        fontSize:'14px'
      },
      green:{
        color:'#4caf50',
        fontSize:'14px'
      },
}));


const AllFeedFormulation = ({ handleClose, showDialog,feedData,medicineData,feedFormulation}) => {
    const classes = useStyles();
    const [feedMaterials, setFeedMaterials] = useState([]);



    // eslint-disable-next-line
    const componentRef = useRef();
    const generatePDF = useReactToPrint({
        content: () => componentRef.current,
    });
    
    const resetBeforeEdit = () => {
        console.debug("data fedmarterials ", feedData)
        if (showDialog) {
            if (feedData.feedMaterial !== undefined && feedData.feedMaterial !== null) {
                setFeedMaterials([...feedData.feedMaterial,
                {
                    id: -1,
                    name: "Total",
                    rate: "",
                    quantity: "",
                    sum: feedData.feedCost
                }]);
            }
        }
    };
    console.log('feed formulation : ',feedFormulation);
    useEffect(resetBeforeEdit, [showDialog]);


    const MedicineTable = ()=>{
        return(
            <MaterialTable
            columns={[
                {title: 'feedFormulationID', field: 'feedFormulationID', hidden: true},
                {title: 'id', field: 'id', hidden: true},
                {title: 'Medicines/Feed Supplement', field: 'materialTypeName'},
                {title: 'Quantity', field: 'quantity'},
            ]}
            data={medicineData || [] }
            options={{
                actionsColumnIndex: -1,
                search: false,
                paging: false
            }}
            title='Medicines'
        />
        );
    };
    const FeedMaterialTable = ()=>{
        return(
            <MaterialTable
            columns={[
                {title: 'feedFormulationID', field: 'feedFormulationID', hidden: true},
                {title: 'id', field: 'id', hidden: true},
                {title: 'Feed Materials', field: 'materialTypeName'},
                {title: 'Quantity', field: 'quantity'},
            ]}
            data={feedData || [] }
            options={{
                actionsColumnIndex: -1,
                search: false,
                paging: false
            }}
            title='Materials'
        />
        );
    };


    return (
    <>
    {
        (feedFormulation === undefined) ?
        <></>
        :
        <Dialog disableBackdropClick open={showDialog} onClose={handleClose} aria-labelledby="form-dialog-title" maxWidth="lg" fullWidth={true}>
        <DialogTitle id="form-dialog- title"> All Formulations
        <IconButton aria-label="close" className={classes.closeButton} onClick={handleClose}>
          <CloseIcon />
        </IconButton>
        </DialogTitle>
          <DialogContent>
          <Grid item>
                <Button variant="outlined" color="primary" className={classes.downloadPdfButton}
                    onClick={generatePDF} endIcon={<PictureAsPdfIcon />}>Download
                        PDF</Button>
            </Grid>
            <div id='report-container' className={classes.reportContainer} ref={componentRef} style={{padding:'15px'}}>
            <Grid
                container
                justify='space-between'
                alignItems='flex-end'
            >
                <Grid item className={classes.grid}>
                    <Typography variant="h5" component="h2">
                       {feedFormulation['date']}
                    </Typography>
                    <Typography color="textSecondary">
                        Date
                    </Typography>
                </Grid>
                <Grid item className={classes.grid}>
                    <Typography variant="h5" component="h2">
                      {feedFormulation['farmName']}
                    </Typography>
                    <Typography color="textSecondary">
                        Farm
                    </Typography>
                </Grid>
                <Grid item className={classes.grid}>
                    <Typography variant="h5" component="h2">
                       {feedFormulation['shedName']}
                    </Typography>
                    <Typography color="textSecondary">
                        Shed
                    </Typography>
                </Grid>
                <Grid item className={classes.grid}>
                    <Typography variant="h5" component="h2">
                        {(feedMaterials) ? feedMaterials.length: 0}
                    </Typography>
                    <Typography color="textSecondary">
                         Materials
                    </Typography>
                </Grid>
                <Grid item className={classes.grid}>
                    <Typography variant="h5" component="h2">
                       {(medicineData) ? medicineData.length: 0 }
                    </Typography>
                    <Typography color="textSecondary">
                        Medicines
                    </Typography>
                </Grid>
                <Grid item className={classes.grid}>
                    <Typography variant="h5" component="h2">
                        {(feedFormulation['isActive'] === 'Active') ? <FiberManualRecordIcon className={classes.green} />
                                : <FiberManualRecordIcon className={classes.red} /> }
                        {feedFormulation['isActive']}
                    </Typography>
                    <Typography color="textSecondary">
                        Status
                    </Typography>
                </Grid>
            </Grid>
            <br/>
            <FeedMaterialTable/>
                <br/>
            <MedicineTable/>
            </div>
          </DialogContent>
    </Dialog>
    }
    </>);
};

export default AllFeedFormulation;